export const MARKETS = [
  {
    countryCode: 'US',
    localizationKey: _TL_('United States'),
    currencyId: 12,
    currency: 'USD',
    currencyLocalizationKey: _TL_('USD'),
    phonePrefix: '+1',
    phoneFormat: '(###) ###-####',
    locationFilter: 'united states',
  },
  {
    countryCode: 'GB',
    localizationKey: _TL_('United Kingdom'),
    currencyId: 7,
    currency: 'GBP',
    currencyLocalizationKey: _TL_('GBP'),
    phonePrefix: '+44',
    phoneFormat: '###-###-####',
    locationFilter: 'great britain',
  },
  {
    countryCode: 'AU',
    localizationKey: _TL_('Australia'),
    currencyId: 1,
    currency: 'AUD',
    currencyLocalizationKey: _TL_('AUD'),
    phonePrefix: '+61',
    phoneFormat: '# #### ####',
    locationFilter: 'australia',
  },
  {
    countryCode: 'CA',
    localizationKey: _TL_('Canada'),
    currencyId: 3,
    currency: 'CAD',
    currencyLocalizationKey: _TL_('CAD'),
    phonePrefix: '+1',
    phoneFormat: '###-###-####',
    locationFilter: 'canada',
  },
  {
    countryCode: 'FR',
    localizationKey: _TL_('France'),
    currencyId: 6,
    currency: 'EUR',
    currencyLocalizationKey: _TL_('EUR'),
    phonePrefix: '+33',
    phoneFormat: '### ## ## ##',
    locationFilter: 'france',
  },
  {
    countryCode: 'DE',
    localizationKey: _TL_('Germany'),
    currencyId: 6,
    currency: 'EUR',
    currencyLocalizationKey: _TL_('EUR'),
    phonePrefix: '+49',
    phoneFormat: '## ######',
    locationFilter: 'germany',
  },
  {
    countryCode: 'IE',
    localizationKey: _TL_('Ireland'),
    currencyId: 6,
    currency: 'EUR',
    currencyLocalizationKey: _TL_('EUR'),
    phonePrefix: '+353',
    phoneFormat: '# ### ####',
    locationFilter: 'ireland',
  },
  {
    countryCode: 'IL',
    localizationKey: _TL_('Israel'),
    currencyId: 12,
    currency: 'USD',
    currencyLocalizationKey: _TL_('USD'),
    phonePrefix: '+972',
    phoneFormat: '#-###-####',
    locationFilter: 'israel',
  },
  {
    countryCode: 'IN',
    localizationKey: _TL_('India'),
    currencyId: 36,
    currency: 'INR',
    currencyLocalizationKey: _TL_('INR'),
    phonePrefix: '+91',
    phoneFormat: '#### ####',
    locationFilter: 'india',
  },
  {
    countryCode: 'SG',
    localizationKey: _TL_('Singapore'),
    currencyId: 74,
    currency: 'SGD',
    currencyLocalizationKey: _TL_('SGD'),
    phonePrefix: '+65',
    phoneFormat: '#### ####',
    locationFilter: 'singapore',
  },
  {
    countryCode: 'NZ',
    localizationKey: _TL_('New Zealand'),
    currencyId: 10,
    currency: 'NZD',
    currencyLocalizationKey: _TL_('NZD'),
    phonePrefix: '+64',
    phoneFormat: '#-### ####',
    locationFilter: 'new zealand',
  },
  {
    countryCode: 'IT',
    localizationKey: _TL_('Italy'),
    currencyId: 6,
    currency: 'EUR',
    currencyLocalizationKey: _TL_('EUR'),
    phonePrefix: '+39',
    phoneFormat: '## #####',
    locationFilter: 'italy',
  },
  {
    countryCode: 'NL',
    localizationKey: _TL_('Netherlands'),
    currencyId: 6,
    currency: 'EUR',
    currencyLocalizationKey: _TL_('EUR'),
    phonePrefix: '+31',
    phoneFormat: '## ### ####',
    locationFilter: 'netherlands',
  },
  {
    countryCode: 'PT',
    localizationKey: _TL_('Portugal'),
    currencyId: 6,
    currency: 'EUR',
    currencyLocalizationKey: _TL_('EUR'),
    phonePrefix: '+351',
    phoneFormat: '## ### ####',
    locationFilter: 'portugal',
  },
  {
    countryCode: 'BR',
    localizationKey: _TL_('Brazil'),
    currencyId: 2,
    currency: 'BRL',
    currencyLocalizationKey: _TL_('BRL'),
    phonePrefix: '+55',
    phoneFormat: '## #### ####',
    locationFilter: 'brazil',
  },
  {
    countryCode: 'ES',
    localizationKey: _TL_('Spain'),
    currencyId: 6,
    currency: 'EUR',
    currencyLocalizationKey: _TL_('EUR'),
    phonePrefix: '+34',
    phoneFormat: '### ### ###',
    locationFilter: 'spain',
  },
  {
    countryCode: 'AR',
    localizationKey: _TL_('Argentina'),
    currencyId: 15,
    currency: 'ARS',
    currencyLocalizationKey: _TL_('ARS'),
    phonePrefix: '+54',
    phoneFormat: '###-###-####',
    locationFilter: 'argentina',
  },
  {
    countryCode: 'MX',
    localizationKey: _TL_('Mexico'),
    currencyId: 57,
    currency: 'MXN',
    currencyLocalizationKey: _TL_('MXN'),
    phonePrefix: '+52',
    phoneFormat: '## #### ####',
    locationFilter: 'mexico',
  },
  {
    countryCode: 'SE',
    localizationKey: _TL_('Sweden'),
    currencyId: 11,
    currency: 'SEK',
    currencyLocalizationKey: _TL_('SEK'),
    phonePrefix: '+46',
    phoneFormat: '# ### ### ##',
    locationFilter: 'sweden',
  },
  {
    countryCode: 'DK',
    localizationKey: _TL_('Denmark'),
    currencyId: 5,
    currency: 'DKK',
    currencyLocalizationKey: _TL_('DKK'),
    phonePrefix: '+45',
    phoneFormat: '## ## ## ##',
    locationFilter: 'denmark',
  },
  {
    countryCode: 'JP',
    localizationKey: _TL_('Japan'),
    currencyId: 8,
    currency: 'JPY',
    currencyLocalizationKey: _TL_('JPY'),
    phonePrefix: '+81',
    phoneFormat: '#-####-####',
    locationFilter: 'japan',
  },
];

export const LANGUAGES = [
  {
    language: 'English',
    languageCode: 'EN',
    languageLocalizationKey: _TL_('English'),
  },
  {
    language: 'French',
    languageCode: 'FR',
    languageLocalizationKey: _TL_('French'),
  },
  {
    language: 'German',
    languageCode: 'DE',
    languageLocalizationKey: _TL_('German'),
  },
  {
    language: 'Italian',
    languageCode: 'IT',
    languageLocalizationKey: _TL_('Italian'),
  },
  {
    language: 'Dutch',
    languageCode: 'NL',
    languageLocalizationKey: _TL_('Dutch'),
  },
  {
    language: 'Portuguese',
    languageCode: 'PT',
    languageLocalizationKey: _TL_('Portuguese'),
  },
  {
    language: 'Spanish',
    languageCode: 'ES',
    languageLocalizationKey: _TL_('Spanish'),
  },
  {
    language: 'Danish',
    languageCode: 'DA',
    languageLocalizationKey: _TL_('Danish'),
  },
  {
    language: 'Swedish',
    languageCode: 'SV',
    languageLocalizationKey: _TL_('Swedish'),
  },
  {
    language: 'Japanese',
    languageCode: 'JA',
    languageLocalizationKey: _TL_('Japanese'),
  },
];

export const BING_LOCATIONS = {
  US: {
    BingLocationId: 190,
    CountryCode: 'US',
    LocationType: 'Country',
    Latitude: 39.5036,
    Longitude: -99.0183,
    localizationKey: _TL_('United States'),
  },
  GB: {
    BingLocationId: 188,
    CountryCode: 'GB',
    LocationType: 'Country',
    Latitude: 53.9376,
    Longitude: -2.51901,
    localizationKey: _TL_('United Kingdom'),
  },
  AU: {
    BingLocationId: 9,
    CountryCode: 'AU',
    LocationType: 'Country',
    Latitude: -25.575,
    Longitude: 134.355,
    localizationKey: _TL_('Australia'),
  },
  CA: {
    BingLocationId: 32,
    CountryCode: 'CA',
    LocationType: 'Country',
    Latitude: 62.5724,
    Longitude: -96.5672,
    localizationKey: _TL_('Canada'),
  },
  FR: {
    BingLocationId: 66,
    CountryCode: 'FR',
    LocationType: 'Country',
    Latitude: 46.6238,
    Longitude: 2.45556,
    localizationKey: _TL_('France'),
  },
  DE: {
    BingLocationId: 72,
    CountryCode: 'DE',
    LocationType: 'Country',
    Latitude: 51.0933,
    Longitude: 10.3803,
    localizationKey: _TL_('Germany'),
  },
  IE: {
    BingLocationId: 92,
    CountryCode: 'IE',
    LocationType: 'Country',
    Latitude: 53.1779,
    Longitude: -8.14886,
    localizationKey: _TL_('Ireland'),
  },
  IL: {
    BingLocationId: 210,
    CountryCode: 'IL',
    LocationType: 'Country',
    Latitude: 30.7209,
    Longitude: 34.8856,
    localizationKey: _TL_('Israel'),
  },
  IN: {
    BingLocationId: 90,
    CountryCode: 'IN',
    LocationType: 'Country',
    Latitude: 22.3519,
    Longitude: 79.3628,
    localizationKey: _TL_('India'),
  },
  SG: {
    BingLocationId: 164,
    CountryCode: 'SG',
    LocationType: 'Country',
    Latitude: 1.3564,
    Longitude: 103.808,
    localizationKey: _TL_('Singapore'),
  },
  NZ: {
    BingLocationId: 134,
    CountryCode: 'NZ',
    LocationType: 'Country',
    Latitude: -43.9858,
    Longitude: 170.481,
    localizationKey: _TL_('New Zealand'),
  },
  IT: {
    BingLocationId: 93,
    CountryCode: 'IT',
    LocationType: 'Country',
    Latitude: 43.5255,
    Longitude: 12.16,
    localizationKey: _TL_('Italy'),
  },
  NL: {
    BingLocationId: 129,
    CountryCode: 'NL',
    LocationType: 'Country',
    Latitude: 52.2691,
    Longitude: 5.6114,
    localizationKey: _TL_('Netherlands'),
  },
  PT: {
    BingLocationId: 152,
    CountryCode: 'PT',
    LocationType: 'Country',
    Latitude: 39.6823,
    Longitude: -7.96831,
    localizationKey: _TL_('Portugal'),
  },
  BR: {
    BingLocationId: 20,
    CountryCode: 'BR',
    LocationType: 'Country',
    Latitude: -10.7522,
    Longitude: -53.0812,
    localizationKey: _TL_('Brazil'),
  },
  ES: {
    BingLocationId: 170,
    CountryCode: 'ES',
    LocationType: 'Country',
    Latitude: 40.3901,
    Longitude: -3.5544,
    localizationKey: _TL_('Spain'),
  },
  AR: {
    BingLocationId: 8,
    CountryCode: 'AR',
    LocationType: 'Country',
    Latitude: -35.1924,
    Longitude: -65.1463,
    localizationKey: _TL_('Argentina'),
  },
  MX: {
    BingLocationId: 119,
    CountryCode: 'MX',
    LocationType: 'Country',
    Latitude: 23.9316,
    Longitude: -102.508,
    localizationKey: _TL_('Mexico'),
  },
  SE: {
    BingLocationId: 174,
    CountryCode: 'SE',
    LocationType: 'Country',
    Latitude: 62.8384,
    Longitude: 16.7431,
    localizationKey: _TL_('Sweden'),
  },
  DK: {
    BingLocationId: 53,
    CountryCode: 'DK',
    LocationType: 'Country',
    Latitude: 56.0348,
    Longitude: 9.31907,
    localizationKey: _TL_('Denmark'),
  },
  JP: {
    BingLocationId: 96,
    CountryCode: 'JP',
    LocationType: 'Country',
    Latitude: 36.6542,
    Longitude: 137.977,
    localizationKey: _TL_('Japan'),
  },
};

export const ACCOUNT_SUPPORTED_ADDRESSES_TO_APPEND = [
  {
    countryCode: 'CN',
    localizationKey: _TL_('China'),
    // we don't support CNY, so use USD for now
    currencyId: 12,
    currency: 'USD',
    currencyLocalizationKey: _TL_('USD'),
    phonePrefix: '+86',
    phoneFormat: '### #### ####',
    locationFilter: 'china',
    isFbChannelAllowed: true,
    isGoogleChannelAllowed: true,
  },
];

